/**
 * Copyright (C) 2013-2018 MNEMOTIX <http://www.mnemotix.com/> and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {StoreObject} from "@apollo/client";
import {generateUpdateCallback} from "./generateUpdateCallback";
import {normalizeMutationInput} from "./normalizeMutationInput";

/**
 * @param {StoreObject} [initialObject] - initialObject object that must contain an "id" field.
 * @param {object} mutatedObject - object representing mutating mutatedObject (can be straight formik form result mutatedObject)
 * @param {MutationConfig} mutationConfig - restrict field input names. Default to all simple field (not link) foundable in "mutatedObject"
 * @param {boolean} [optimistic=true] - is mutation optimistic ?
 * @return {{updateCache: updateCache, objectInput: any}}
 */
export function prepareMutation({initialObject, mutatedObject, mutationConfig, optimistic = true} = {}) {
  const scalarInputNames = mutationConfig.scalarInputNames;
  const linkInputDefinitions = mutationConfig.linkInputDefinitions;

  return {
    objectInput: normalizeMutationInput({initialObject, mutatedObject, linkInputDefinitions, scalarInputNames}),
    updateCache: initialObject ? generateUpdateCallback({initialObject, mutatedObject, linkInputDefinitions, scalarInputNames, optimistic}) : () => {}
  };
}

